import { updateLessonTag } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useUpdateLessonTag = () => {
    const { callAPI, loading } = useWorkspaceApiCall(updateLessonTag, '', 'updateUserTag.error');

    return { updateLessonTag: callAPI, updatingLessonTag: loading };
}